
<template>
  <helper-layout :loaded="mx_loaded">
    <v-layout row wrap>
      <v-flex xs12 text-xs-left>
        <v-card class="details-wrap">
          <div class="detail-title" :style="`color:${getPrimary(color)}`">
            {{ $t("Views.Customer.customerName") }}
          </div>
          <v-autocomplete
            v-model="form.customerId"
            style="width:300px"
            :items="customerList"
            :placeholder="$t('Views.Customer.customerName')"
            :search-input.sync="search"
            return-object
            clearable
            @change="customerChange"
          >
            <template v-slot:no-data>
              <v-list-tile>
                <v-list-tile-title>
                  <v-icon class="nodataicon" /><span class="notext">{{
                    $t("Core.System.notSearchedAnyData")
                  }}</span>
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </v-autocomplete>
          <div v-if="signDate">
            {{ $t("Views.Customer.signDate") }}: {{ signDate }}
          </div>
        </v-card>
        <v-card class="details-wrap margin-top-20">
          <category-discount
            ref="category"
            v-model="form.productCategoryDicounts"
          />
        </v-card>
        <v-card class="details-wrap margin-top-20">
          <product-discount
            ref="product"
            v-model="form.productDiscounts"
          />
        </v-card>
        <div class="margin-top-20">
          <h3 class="layout-title">
            {{ $t("Views.Customer.discount") }}
          </h3>
          <div class="tab-item">
            <p class="table-title">
              {{
                $t("Views.Customer.discountapproved", { "0": discounts.length })
              }}
            </p>
            <material-table
              :headers="discountHeaders"
              :items="discounts"
              :has-paginate="false"
              :total-count="discounts.totalCount"
            />
          </div>
          <div class="tab-item margin-top-20">
            <p class="table-title">
              {{
                $t("Views.Customer.levelDiscount", {
                  "0": levelDiscounts.length
                })
              }}
            </p>
            <material-table
              :headers="discountHeaders"
              :items="levelDiscounts"
              :has-paginate="false"
              :total-count="levelDiscounts.totalCount"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-flex xs12 text-xs-center class="btn-bottom">
      <v-btn v-clickthrottle="{ handle: save, delay: 3000 }" :color="color">
        {{ $t("Core.System.save") }}
      </v-btn>
      <v-btn color="cancel" outline @click="() => $router.go(-1)">
        {{ $t("Core.System.back") }}
      </v-btn>
    </v-flex>
  </helper-layout>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import categoryDiscount from './components/categoryDiscountTable'
import productDiscount from './components/productDiscountTable'
import ENUMS from '@/dict/enums'
export default {
  components: {
    categoryDiscount,
    productDiscount
  },
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      form: {
        customerId: '',
        productCategoryDicounts: [{
          productCategoryId: '',
          detail: null
        }],
        productDiscounts: [{
          productId: '',
          detail: null
        }]
      },
      search: '',
      customerList: [],
      signDate: null,
      discountHeaders: [
        {
          text: $t('Views.Customer.productCategoryName'),
          value: 'productId',
          render: (h, param) => {
            return h('div', param.row['productCategory'] && param.row['productCategory']['name'])
          }
        },
        {
          text: $t('Views.Customer.productName'),
          value: 'name',
          render: (h, param) => {
            return h('div', param.row['product'] && param.row['product']['name'])
          }
        },
        {
          // 数量区间
          text: $t('Views.Customer.quantity'),
          render: (h, param) => {
            return h(
              'div',
              {
                props: {},
                domProps: {
                  innerHTML: param.row.detail
                    .map(item => `${item.minQuantity} - ${item.maxQuantity}`)
                    .join('<br/>')
                }
              }
            )
          }
        },
        {
          text: $t('Views.Customer.discountPrice'),
          value: 'dicountPrice',
          render: (h, param) => {
            return h(
              'div',
              {
                props: {},
                domProps: {
                  innerHTML: param.row.product
                    ? param.row.detail.map(item => `${this.$util.data.toThousands(item.discountValue)}`).join('<br/>')
                    : param.row.detail.map(item => `${item.discountValue}%`).join('<br/>')
                }
              }
            )
          }
        }
      ],
      discounts: [],
      levelDiscounts: []
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    },
    ...mapState('customer', ['customersListNoPermissionData', 'customerDetails']),
    ...mapState('setting', ['customerLevel'])
  },
  watch: {
    search(newValue, oldValue) {
      newValue && this.getCustomerList(newValue)
    }
  },
  mounted() {
    this.mx_loaded_fn() // 页面加载完成
  },
  methods: {
    ...mapActions('customer', ['getCustomersNoPermission', 'createCustomerDiscount', 'getCustomerDetails']),
    ...mapMutations('app', ['setNotification']),
    ...mapActions('setting', ['getCustomerLevelDetails']),
    customerChange(val) {
      if (val) {
        this.form.customerId = val.id
        this.signDate = this.$util.tool.dateToStringFormat(val.signDate)

        this.getCustomerDetails(val.id).then(() => {
          this.discounts = this.customerDetails.productCategoryDicounts.concat(this.customerDetails.porductDiscounts)
        })
        if (val.levelId) {
          this.getCustomerLevelDetails(val.levelId).then(() => {
            this.levelDiscounts = this.customerLevel.productCategoryDiscounts.concat(this.customerLevel.productDiscounts)
          })
        }
      } else {
        this.signDate = undefined
      }
    },
    getPrimary(color) {
      return ENUMS.primaryColor[color]
    },
    getCustomerList(filter) {
      this.getCustomersNoPermission({
        status: 'Active',
        skipCount: 0,
        maxResultCount: 10,
        filter: filter.split('/')[0]
      }).then(() => {
        this.customerList = this.customersListNoPermissionData.items.map(i => {
          i.value = i.id
          i.text = i.name + ' / ' + i.email
          return i
        })
      })
    },
    getItems(value) { },
    save() {
      const errorMsg = {
        section: this.$t('Core.Valid.section'),
        rate: this.$t('Core.Valid.rate'),
        price: this.$t('Core.Valid.price')
      }
      // 更新数据
      const productValid = this.$refs.product.emitChange()
      const categoryValid = this.$refs.category.emitChange()
      const submitForm = this.formatForm()

      if (!submitForm.customerId) { // 没有选择客户名
        this.setNotification({
          msg: this.$t('Core.Valid.customer'),
          type: 'warning'
        })
        return
      }

      // 校验
      const productKey = this.$_.findKey(productValid, (o) => !o)
      const categoryKey = this.$_.findKey(categoryValid, (o) => !o)

      if (!productValid.goods && !categoryValid.category) {
        this.setNotification({
          msg: this.$t('Core.Valid.add'),
          type: 'warning'
        })

        return
      }

      if (errorMsg[productKey] || errorMsg[categoryKey]) {
        this.setNotification({
          msg: errorMsg[productKey] || errorMsg[categoryKey],
          type: 'warning'
        })

        return
      }

      // 新建客户折扣
      this.createCustomerDiscount(submitForm).then(res => {
        this.$router.push({ name: 'customerDiscounts' })
      })
    },
    formatForm() {
      const productCategoryDicounts = this.form.productCategoryDicounts.filter(item => item.productCategoryId)
      const productDiscounts = this.form.productDiscounts.filter(item => item.productId)
      return {
        customerId: this.form.customerId,
        productCategoryDicounts,
        productDiscounts
      }
    }
  }
}
</script>

<style scoped>
.layout-title {
  padding: 0 0 0 20px;
  margin: 2px 0 20px 0;
  color: #4caf50;
  font-size: 18px !important;
  font-weight: 700 !important;
}
.tab-item {
  background: #fff;
  border-radius: 10px;
  padding: 0 10px;
}
.table-title {
  font-size: 14px;
  margin: 0;
  padding: 16px 0 16px 20px;
  color: #515151;
}
</style>
